export default __webpack_public_path__ + "static/media/Amazon-VPC_light-bg.7e06f399.svg";